import React from "react";
import { Box } from '@mui/joy';
import { Bar } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import KPIFunnelSet from "./KPIFunnelSet";
import KPICostSet from "./KPICostSet";
import KPIBudgetSet from "./KPIBudgetSet";

const IndicatoriDiSintesi = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPIFunnel = true;
    const showKPIBudget = true;
    const showKPICost = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Indicatori di Sintesi')}</h2>
            </Box>

            {showKPIFunnel &&
                <Box className="report-itemgroup">
                    <KPIFunnelSet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showKPICost &&
                <Box className="report-itemgroup">
                    <KPICostSet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showKPIBudget &&
                <Box className="report-itemgroup">
                    <KPIBudgetSet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }
        </Box>
    )
}

export default IndicatoriDiSintesi;